import { useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsSuspense } from '@shared/integrations/umbraco-taf-delivery-api/features/object-booking/object-booking.ts';
import BookingObjectListItem from '@my-pages/features/object-booking/components/BookingObjectListItem.tsx';

interface IBookingObjectsListProps {
    contentId: string;
}
const BookingObjectsListDescendants = ({ contentId }: IBookingObjectsListProps) => {
    const { data } = useGetUmbracoTafDeliveryApiV1BookingObjectsListDockumentKeyDecendantsSuspense(contentId);
    return (
        <div className='row'>
            {data?.map((x) => (
                <div
                    key={x.id}
                    className='col-md-4 pb-4'
                >
                    <BookingObjectListItem item={x} />
                </div>
            ))}
        </div>
    );
};

export default BookingObjectsListDescendants;
